<template>
	<div>
		<input type="hidden" :value="Totales">
		<!-- <input type="hidden" :value="bloker"> -->
		<CHead :oHead="Head"></CHead>
		<div class="row justify-content-start mt-3">
			<div class="col-12 col-sm-12 col-md-12 col-lg-12">
				<div class="card card-01">
					<div class="row">
						<div class="col-md-12 col-lg-12">
							<form class="form-inline justify-content-center">
								<label class="mr-1">Año </label>
								<select :disabled="loading" @change="get_listdata(1)"  v-model="Anio" class="form-control mr-2">
                                    <option v-for="(item,index) in ListaAnios" :key="index" :value="item">{{item}}</option>
                                </select>

								<button :disabled="loading" @click="Guardar" type="button"  class="btn btn-01">
                                    <i v-show="loading" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
                                    <i class="fa fa-plus-circle"></i>
                                    {{txtSave}}
                                </button>
							</form>
							<hr>
						</div>
					</div>
					<CLoader :pConfigLoad="ConfigLoad">
						<template slot="BodyFormLoad">
							<div class="row mt-2">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12">
									<div class="table-venta">
										<table class="table-venta-01">
											<thead>
												<tr>
                								    <th class="sticky marca" scope="col">Concepto</th>
                								    <th scope="col">Trimeste 1</th>
                								    <th scope="col">Trimestre 2</th>
                								    <th scope="col">Trimestre 3</th>
                								    <th scope="col">Trimestre 4</th>
                								    <th scope="col">Total</th>
                								</tr>
											</thead>
											<tbody>
												<tr v-for="(item,index) in ListaDetalle" :key="index">
													<td class="sticky">
														<div class="row">
															<div class="col-lg-7 mt-1">
																<span class="bold" style="font-size:16px">{{item.Nombre}}</span>
															</div>
															<div class="col-lg-5">
																<button @click="AbrirModalDetalle(item.Anio,item.IdConfigS,item.ListaDetalle,item.UnoT,item.DosT,item.TresT,item.CuatroT)" class="btn btn-outline-secondary" style="border:0;font-size:20px !important" v-b-tooltip.hover.top title="Ver Detalles" data-toggle="modal" :data-target="'#baseactualform'"><i style="" class="fa fa-plus-circle"></i></button>
															</div>
														</div>
													</td>
													<td>
                    								    <vue-numeric :disabled="true" placeholder="$ 0.00" class="form-control form-finanza form-control-sm text-center bold" currency="$" separator="," :precision="2" v-model="item.UnoT"/>
													</td>
													<td>
                    								    <vue-numeric :disabled="true" placeholder="$ 0.00" class="form-control form-finanza form-control-sm text-center bold" currency="$" separator="," :precision="2" v-model="item.DosT"/>
                    								</td>
													<td>
														<vue-numeric :disabled="true" placeholder="$ 0.00" class="form-control form-finanza form-control-sm text-center bold" currency="$" separator="," :precision="2" v-model="item.TresT"/>
													</td>
													<td>
														<vue-numeric :disabled="true" placeholder="$ 0.00" class="form-control form-finanza form-control-sm text-center bold" currency="$" separator="," :precision="2" v-model="item.CuatroT"/>
													</td>
													<td>
														<vue-numeric :disabled="true"  placeholder="$ 0.00" class="form-control form-finanza form-control-sm text-center bold" currency="$" separator="," :precision="2" v-model="item.BaseActual"/>
													</td>
												</tr>
											</tbody>
											<tfoot>
												<tr>
													<td class="color-01 bold sticky marca">Totales</td>
													<td><vue-numeric disabled class="form-control form-finanza form-control-sm color-01 bold text-center" currency="$" separator="," :precision="2" v-model="Trimestre1"></vue-numeric></td>
													<td><vue-numeric disabled class="form-control form-finanza form-control-sm color-01 bold text-center" currency="$" separator="," :precision="2" v-model="Trimestre2"></vue-numeric></td>
													<td><vue-numeric disabled class="form-control form-finanza form-control-sm color-01 bold text-center" currency="$" separator="," :precision="2" v-model="Trimestre3"></vue-numeric></td>
													<td><vue-numeric disabled class="form-control form-finanza form-control-sm color-01 bold text-center" currency="$" separator="," :precision="2" v-model="Trimestre4"></vue-numeric></td>
													<td><vue-numeric disabled class="form-control form-finanza form-control-sm color-01 bold text-center" currency="$" separator="," :precision="2" v-model="TotalGral"></vue-numeric></td>
												</tr>
											</tfoot>
										</table>
									</div>
								</div>
							</div>
						</template>
					</CLoader>
				</div>
			</div>
		</div>
		<Modal :Nombre="ModalNombre" :NameModal="'baseactualform'" :size="'modal-xl'" :pEmitSeccion="'baseactualform'" :poBtnSave="oBtnSave">
        	<template slot="Form">
        	    <Form :pEmitSeccion="'baseactualform'"></Form>
        	</template>
    	</Modal>
	</div>
</template>

<script>
import CHead from "../../../../components/CHead";
import Modal from '@/components/Cmodal.vue';
import Form from "./FormBase.vue";
export default {
	name:'BaseActual',
	components:{
		CHead,Modal,Form
	},
	data() {
		return {
			BaseActual:[],
			ListaDetalle:[],
			Head:{
				Title:'Base Actual Ventas',
                BtnNewShow:false,
                BtnNewName:'Nuevo',
                isreturn:true,
                isModal:false,
                isEmit:false,
                Url:'SubMenusFinanzas',
                ObjReturn:'',
			},
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:false
			},
			Anio:'2020',
			txtSave:'Guardar',
            ListaAnios:[],
			blockBtn: false,
			loading:false,
			
			Trimestre1:0,
            Trimestre2:0,
            Trimestre3:0,
            Trimestre4:0,
            Propuesta1:0,
            Propuesta2:0,
            Propuesta3:0,
            Propuesta4:0,
            TotalGral:0,
            price:'',
            Decimal:1,
			oBtnSave:{
				nombreModal:"baseactualform",
				EmitSeccion:"baseactualform",
				txtSave:"Confirmar"
			},
			ModalNombre:'Base Actual',
			BndUnoT:false
		}
	},
	methods: {
		get_anios(){
			this.blockBtn = true;
			this.$http.get(
                'funciones/getanios',
                {
                    params:{}
                }
            ).then( (res) => {
              this.ListaAnios 	= res.data.ListaAnios;
              this.Anio 		= res.data.AnioActual;
			  this.GetListData();
            });
		},
		async GetListData(){
			this.BndUnoT=false;
			this.ConfigLoad.ShowLoader=true;
			this.ConfigLoad.ClassLoad=false;
			this.$http.get('baseactualdata/get', {
				params:{
					Anio:this.Anio
				}
			}).then( (res) => {
				this.ListaDetalle	= res.data.data.detalle;
				this.ListaDetalle.forEach(element => {
					if (element.UnoT==0 && element.BaseActual!=0) {
						this.BndUnoT=true;
						element.UnoT+=element.BaseActual;
					}
				});
				this.loading 		= false;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader=false;
				this.ConfigLoad.ClassLoad=true;
			});
		},
		async Guardar(){
			this.loading=true;
			let formData=new FormData();
			let Detalle=[];
			this.ListaDetalle.forEach((value) => {
				Detalle.push(...value.ListaDetalle);
			});
			// console.log(Detalle);
			// return false;
			formData.set('Anio',this.Anio);
			formData.set('Detalle',JSON.stringify(Detalle));
			await this.$http.post('baseactual/post',formData).then((res)=>{
				this.$toast.success('Información Guardada');
				this.GetListData();
			}).catch((err)=>{
				this.$toast.warning('Error Al Guardar La Información');
				this.loading=false;
			});
		},
		AbrirModalDetalle(Anio,IdConfigS,DetalleCuenta,PrimerT,SegundoT,TercerT,CuartoT){
			// console.log(DetalleCuenta);
			switch (Number(IdConfigS)) {
				case 1:
					this.ModalNombre='Mantenimiento';
					break;
				case 2:
					this.ModalNombre='Servicio';
					break;
				case 3:
					this.ModalNombre='Proyecto';
					break;
				default:
					break;
			}
			this.bus.$emit('PassDetallesCuenta',Anio,IdConfigS,DetalleCuenta,PrimerT,SegundoT,TercerT,CuartoT,this.BndUnoT);
		}
	},
	created() {
		this.get_anios();
		this.bus.$off('Regresar');
		this.bus.$on('Regresar',()=> {
			this.$router.push({name:'SubMenusFinanzas'});
		});
		this.bus.$off('IgualarTrimestres');
		this.bus.$on('IgualarTrimestres',(Anio,IdConfigS,PrimerT,SegundoT,TercerT,CuartoT)=>{
            let index=this.ListaDetalle.findIndex((element)=>element.IdConfigS==IdConfigS);
            this.ListaDetalle[index].UnoT=PrimerT;
            this.ListaDetalle[index].DosT=SegundoT;
            this.ListaDetalle[index].TresT=TercerT;
            this.ListaDetalle[index].CuatroT=CuartoT;
            $('#baseactualform').modal("hide");
			// console.log("A");
        });
    },
	computed: {
		Totales(){
			this.Trimestre1=0;
			this.Trimestre2=0;
			this.Trimestre3=0;
			this.Trimestre4=0;
			this.TotalGral=0;
			this.Propuesta1=0;
			this.Propuesta2=0;
			this.Propuesta3=0;
			this.Propuesta4=0;
			let fixed=0;

			for ( let i =0;i<this.ListaDetalle.length;i++ ){
				let Total =0;
				if (this.ListaDetalle[i].UnoT !== ''){
					this.Trimestre1 +=parseFloat( this.ListaDetalle[i].UnoT);
					Total +=parseFloat( this.ListaDetalle[i].UnoT);
				}
				if (this.ListaDetalle[i].DosT !=''){
					this.Trimestre2 +=parseFloat( this.ListaDetalle[i].DosT);
					Total   +=parseFloat( this.ListaDetalle[i].DosT);
				}
				if (this.ListaDetalle[i].TresT !=''){
					this.Trimestre3 +=parseFloat( this.ListaDetalle[i].TresT);
					Total   +=parseFloat( this.ListaDetalle[i].TresT);
				}
				if (this.ListaDetalle[i].CuatroT !=''){
					this.Trimestre4 +=parseFloat( this.ListaDetalle[i].CuatroT);
                	Total   +=parseFloat( this.ListaDetalle[i].CuatroT);
				}
				this.TotalGral +=parseFloat(Total);

                if (Total==0) {
					this.TotalGral+=this.ListaDetalle[i].BaseActual;	
				}
				else{
					this.ListaDetalle[i].BaseActual =parseFloat(Total);
				}
			}
			return this.ListaDetalle;
		}
	},
}
</script>

<style>

</style>
